import React from 'react';
import styled, { keyframes, css, useTheme } from 'styled-components/macro';
import { BsFillPlayCircleFill, BsFillStopCircleFill } from 'react-icons/bs';

interface AudioPlayerIconProps {
  isPlaying: boolean;
  onClick: () => void;
}

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.9;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const AnimatedIconWrapper = styled.div<{ isPlaying: boolean }>`
  display: inline-flex;
  cursor: pointer;
  overflow: visible;
  padding: 2px;

  ${({ isPlaying }) =>
    isPlaying &&
    css`
      animation: ${pulse} 2.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    `}
`;

export const AudioPlayerIcon = ({
  isPlaying,
  onClick,
}: AudioPlayerIconProps) => {
  const theme = useTheme();

  const IconComponent = isPlaying ? BsFillStopCircleFill : BsFillPlayCircleFill;

  return (
    <AnimatedIconWrapper isPlaying={isPlaying} onClick={onClick}>
      <IconComponent size={24} color={theme.colors.primary[100]} />
    </AnimatedIconWrapper>
  );
};
